import styled from 'styled-components';
import { RULER_HEIGHT } from '@src/constants/timeline';
import { COLOR } from '@src/styles/color';
import { GUTTER_WIDTH } from '../TimelineGrid';

// Covers the whole grid (gutter + viewport) and is clipped only at the
// timeline's outer edges — so the centred chip can overlap the gutter, but it
// never spills outside the timeline. Click-through except the ruler strip/chip.
// z-index sits ABOVE the in-content playhead line (z-index 5) so the chip is
// drawn on top of the line instead of the line cutting across its text.
export const StyledOverlay = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow: hidden;
  pointer-events: none;
  z-index: 6;
`;

// Click / drag-to-seek zone for the ruler row. The lanes below seek through
// their own surface handler (see DubbingTimeline); this strip exists because the
// overlay sits above the ruler and would otherwise swallow the press.
export const StyledRulerSeek = styled.div`
  position: absolute;
  top: 0;
  left: ${GUTTER_WIDTH}px;
  right: 0;
  height: ${RULER_HEIGHT}px;
  pointer-events: auto;
  cursor: ew-resize;
  touch-action: none;
  user-select: none;
`;

// Carries the horizontal-scroll offset (translateX(-scrollLeft)); no transition
// so scrolling stays instant.
export const StyledScrollShift = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 0;
`;

// Carries the time-driven position; the smooth-playback transition lives here.
export const StyledPlayheadPos = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 0;
  will-change: transform;
`;

// The time chip, centred on the line (per Figma). The overlay lets it overlap
// the gutter at the edges without being clipped by the viewport's overflow.
export const StyledChip = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  transform: translateX(-50%);
  pointer-events: auto;
  padding: 4px;
  border-radius: 4px;
  background: ${COLOR.darkBlue};
  color: ${COLOR.white};
  font-size: 12px;
  line-height: 16px;
  white-space: nowrap;
  cursor: ew-resize;
  touch-action: none;
  user-select: none;
`;
